import { ReactElement } from 'react';
import { useBreadcrumbs } from '@client/breadcrumbs/hooks';
import { useLoginUrl } from '@client/context/hooks';
import { useTranslate } from '@client/i18n/hooks';
import { Form } from '@client/myAccount/rma/components/StandaloneSearchPage/Form';
import { CARD_BOX_TITLE_SIZE, CardBox } from '@lib/components/CardBox';
import { Props } from './StandaloneSearchPage.types';

export const StandaloneSearchPage = (props: Props): ReactElement => {
  const t = useTranslate();
  useBreadcrumbs([]);
  const getLoginUrl = useLoginUrl();
  const { className } = props;

  return (
    <CardBox title={t('Create new RMA')} titleSize={CARD_BOX_TITLE_SIZE.large} className={className}>
      <p className='StandaloneSearchPage-Info'>
        {t(
          'If you want to create an RMA and already have an account please',
        )}{' '}
        <a href={getLoginUrl()} className='cds-ButtonLink'>
          {t('log in here')}
        </a>
        {'.'}
      </p>

      <p className='StandaloneSearchPage-Info'>{t(
        'Otherwise you can also register your repair/return with the combination customer number & invoice number:',
      )}</p>
      <Form />
    </CardBox>
  );
};
